import React, { lazy } from "react";
import UIDs from "../../UIDs";

const SettingScreen = lazy(() => import("../../screens/admin/SettingScreen"));
const ServiceSettingScreen = lazy(() => import("../../screens/admin/ServiceSettingScreen"));
const OnCallSettingScreen = lazy(() => import("../../screens/admin/OnCallSettingScreen"));
const CurrencySettingScreen = lazy(() => import("../../screens/admin/CurrencyInfoScreen"));
const FeatureConfigurationScreen = lazy(() => import("../../screens/admin/FeatureConfigurationScreen"));
const ManageProviderScreen = lazy(() => import("../../screens/admin/user/ManageProviderScreen"));
const ManageEmployeeScreen = lazy(() => import("../../screens/admin/user/ManageEmployeeScreen"));
const ManageConsumerScreen = lazy(() => import("../../screens/admin/user/ManageConsumerScreen"));
const ManageRegionUserScreen = lazy(() => import("../../screens/admin/user/ManageRegionUserScreen"));
const ManageStoreUserScreen = lazy(() => import("../../screens/admin/user/ManageStoreUserScreen"));
const ManageCloudStoreUserScreen = lazy(() => import("../../screens/admin/user/ManageCloudStoreUserScreen"));
const ManageMarketerScreen = lazy(() => import("../../screens/admin/user/ManageMarketerScreen"));
const ManageAgentScreen = lazy(() => import("../../screens/admin/user/ManageAgentScreen"));

const TeamCertificationManagementScreen = lazy(() => import("../../screens/admin/user/TeamCertificationManagementScreen"));
const TeamCertificationManagementDetailScreen = lazy(() => import("../../screens/admin/user/TeamCertificationManagementDetailScreen"));

const ServiceTypeScreen = lazy(() => import("../../screens/admin/ServiceTypeScreen"));
const ServiceScreen = lazy(() => import("../../screens/admin/ServiceScreen"));
const RegionScreen = lazy(() => import("../../screens/admin/RegionScreen"));
const RegionServiceScreen = lazy(() => import("../../screens/admin/RegionServiceScreen"));
const RegionSettingScreen = lazy(() => import("../../screens/admin/region/RegionSettingScreen"));
const StoreScreen = lazy(() => import("../../screens/admin/StoreScreen"));
const StoreDetailScreen = lazy(() => import("../../screens/admin/store/StoreDetailScreen"));
const StoreServiceScreen = lazy(() => import("../../screens/admin/store/StoreServiceScreen"));
const StoreAccountScreen = lazy(() => import("../../screens/admin/store/StoreAccountScreen"));
const StoreDashboardScreen = lazy(() => import("../../screens/admin/store/StoreDashboardScreen"));
const StoreRoomTypeScreen = lazy(() => import("../../screens/admin/store/StoreRoomTypeScreen"));
const StoreRoomScreen = lazy(() => import("../../screens/admin/store/StoreRoomScreen"));
const StoreProviderScreen = lazy(() => import("../../screens/admin/store/StoreProviderScreen"));
const StoreGuestScreen = lazy(() => import("../../screens/admin/store/StoreGuestScreen"));
const StoreCollectionBillScreen = lazy(() => import("../../screens/admin/store/StoreCollectionBillScreen"));
const StoreCollectionBillDetailScreen = lazy(() => import("../../screens/admin/store/StoreCollectionBillDetailScreen"));
const StoreProviderCommissionScreen = lazy(() => import("../../screens/admin/store/StoreProviderCommissionScreen"));
const StoreProviderCommissionDetailScreen = lazy(() => import("../../screens/admin/store/StoreProviderCommissionDetailScreen"));
const StoreExpenseLedgerScreen = lazy(() => import("../../screens/admin/store/StoreExpenseLedgerScreen"));
const StoreExpenseLedgerDetailScreen = lazy(() => import("../../screens/admin/store/StoreExpenseLedgerDetailScreen"));
const StoreCouponScreen = lazy(() => import("../../screens/admin/store/StoreCouponScreen"));
const StoreProviderScheduleScreen = lazy(() => import("../../screens/admin/store/StoreProviderScheduleScreen"));
const StoreSettlementPayoutScreen = lazy(() => import("../../screens/admin/store/StoreSettlementPayoutScreen"));
const StoreSettlementPayoutDetailScreen = lazy(() => import("../../screens/admin/store/StoreSettlementPayoutDetailScreen"));
const UserActivityScreen = lazy(() => import("../../screens/admin/user/UserActivityScreen"));
const UserDetailScreen = lazy(() => import("../../screens/admin/user/UserDetailScreen"));
const UserAuthenticationScreen = lazy(() => import("../../screens/admin/user/UserAuthenticationScreen"));
const ReservationDetailScreen = lazy(() => import("../../screens/admin/ReservationDetailScreen"));

const RegionJoinRequestScreen = lazy(() => import("../../screens/admin/RegionJoinRequestScreen"));
const RegionJoinRequestDetailScreen = lazy(() => import("../../screens/admin/RegionJoinRequestDetailScreen"));
const StoreJoinRequestScreen = lazy(() => import("../../screens/admin/StoreJoinRequestScreen"));
const FeedbackScreen = lazy(() => import("../../screens/admin/manager/FeedbackScreen"));
const FeedbackDetailScreen = lazy(() => import("../../screens/admin/manager/FeedbackDetailScreen"));
const ReportScreen = lazy(() => import("../../screens/admin/manager/ReportScreen"));
const ReportDetailScreen = lazy(() => import("../../screens/admin/manager/ReportDetailScreen"));
const GpsMonitorScreen = lazy(() => import("../../screens/admin/GpsMonitorScreen"));
const HelpCenterSettingScreen = lazy(() => import("../../screens/admin/HelpCenterSettingScreen"));
const VerifyCodeManageScreen = lazy(() => import("../../screens/admin/VerifyCodeManageScreen"));

const DashboardScreen = lazy(() => import("../../screens/admin/DashboardScreen"));
const WorkbenchScreen = lazy(() => import("../../screens/admin/WorkbenchScreen"));
const UserStatisticScreen = lazy(() => import("../../screens/admin/statistics/UserStatisticScreen"));
const ProviderStatisticScreen = lazy(() => import("../../screens/admin/statistics/ProviderStatisticScreen"));
const MarketerStatisticScreen = lazy(() => import("../../screens/admin/statistics/MarketerStatisticScreen"));
const OrderStatisticScreen = lazy(() => import("../../screens/admin/statistics/OrderStatisticScreen"));
const IncomeStatisticScreen = lazy(() => import("../../screens/admin/statistics/IncomeStatisticScreen"));
const ProviderWithdrawalScreen = lazy(() => import("../../screens/admin/transaction/ProviderWithdrawalScreen"));
const ConsumerWithdrawalScreen = lazy(() => import("../../screens/admin/transaction/ConsumerWithdrawalScreen"));
const MarketerWithdrawalScreen = lazy(() => import("../../screens/admin/transaction/MarketerWithdrawalScreen"));
const RegionWithdrawalScreen = lazy(() => import("../../screens/admin/transaction/RegionWithdrawalScreen"));
const StoreWithdrawalScreen = lazy(() => import("../../screens/admin/transaction/StoreWithdrawalScreen"));
const AgentWithdrawalScreen = lazy(() => import("../../screens/admin/transaction/AgentWithdrawalScreen"));

const ReservationScreen = lazy(() => import("../../screens/admin/ReservationScreen"));
const CouponScreen = lazy(() => import("../../screens/admin/discount/CouponScreen"));
const PromotionScreen = lazy(() => import("../../screens/admin/discount/PromotionScreen"));
const RegionReservationScreen = lazy(() => import("../../screens/admin/RegionReservationScreen"));
const ReservationRewardPenaltyScreen = lazy(() => import("../../screens/admin/ReservationRewardPenaltyScreen"));
const ErrorListScreen = React.lazy(() => import("../../screens/admin/error/ListScreen"));
const ErrorDetailsScreen = React.lazy(() => import("../../screens/admin/error/DetailsScreen"));
const ErrorDashboardScreen = React.lazy(() => import("../../screens/admin/error/DashboardScreen"));

const CloudStoreRequestScreen = lazy(() => import("../../screens/admin/CloudStoreRequestScreen"));
const CloudStoreScreen = lazy(() => import("../../screens/admin/CloudStoreScreen"));

const ChatHomeScreen = lazy(() => import("../../screens/admin/chat/ChatScreen"));
const ChatListScreen = lazy(() => import("../../screens/admin/chat/ListScreen"));
const DebtScreen = lazy(() => import("../../screens/admin/DebtScreen"));

const ConsumerReviewScreen = lazy(() => import("../../screens/admin/manager/ConsumerReviewScreen"));
const ConsumerReviewDetailScreen = lazy(() => import("../../screens/admin/manager/ConsumerReviewDetailScreen"));
const ProviderReviewScreen = lazy(() => import("../../screens/admin/manager/ProviderReviewScreen"));
const ProviderReviewDetailScreen = lazy(() => import("../../screens/admin/manager/ProviderReviewDetailScreen"));
const ActiveUserConfigScreen = lazy(() => import("../../screens/admin/statistics/ActiveUserConfigScreen"));
const RegionIncomeListScreen = lazy(() => import("../../screens/admin/income/RegionIncomeListScreen"));
const SystemIncomeScreen = lazy(() => import("../../screens/admin/income/SystemIncomeScreen"));
const SystemIncomeValidationScreen = lazy(() => import("../../screens/admin/income/SystemIncomeValidationScreen"));
const MockDataScreen = lazy(() => import("../../screens/admin/MockDataScreen"));
const DataCleanupScreen = lazy(() => import("../../screens/admin/DataCleanupScreen"));
const ProfileScreen = lazy(() => import("../../screens/admin/ProfileScreen"));
const ChooseRegionScreen = lazy(() => import("../../screens/admin/ChooseRegionScreen"));
const OperationStatisticScreen = lazy(() => import("../../screens/admin/statistics/OperationStatisticScreen"));
const AccountScreen = lazy(() => import("../../screens/admin/AccountScreen"));

const AnnouncementScreen = lazy(() => import("../../screens/admin/discount/AnnouncementScreen"));

const TodoTaskScreen = lazy(() => import("../../screens/admin/TodoTaskScreen"));

const CancelReservationWithoutLiabilityRequestScreen = lazy(() => import("../../screens/admin/request/CancelReservationWithoutLiabilityRequestScreen"));
const RejectReservationRequestScreen = lazy(() => import("../../screens/admin/request/RejectReservationRequestScreen"));
const ReservationRefundRequestScreen = lazy(() => import("../../screens/admin/request/ReservationRefundRequestScreen"));
const NewServiceTypeRequestScreen = lazy(() => import("../../screens/admin/request/NewServiceTypeRequestScreen"));
const UserWithdrawalRequestScreen = lazy(() => import("../../screens/admin/request/UserWithdrawalRequestScreen"));
const ReservationRewardPenaltyRequestScreen = lazy(() => import("../../screens/admin/request/ReservationRewardPenaltyRequestScreen"));
const FreeReservationRequestScreen = lazy(() => import("../../screens/admin/request/FreeReservationRequestScreen"));
const TeamCertificationRequestScreen = lazy(() => import("../../screens/admin/request/TeamCertificationRequestScreen"));
const ProviderStoreJoinRequestScreen = lazy(() => import("../../screens/admin/request/ProviderStoreJoinRequestScreen"));

const ConsumerIncomeScreen = lazy(() => import("../../screens/admin/income/ConsumerIncomeScreen"));
const ProviderIncomeScreen = lazy(() => import("../../screens/admin/income/ProviderIncomeScreen"));
const MarketerIncomeScreen = lazy(() => import("../../screens/admin/income/MarketerIncomeScreen"));

const FreeReservationScreen = lazy(() => import("../../screens/admin/discount/FreeReservationScreen"));
const PosterScreen = lazy(() => import("../../screens/admin/discount/PosterScreen"));
const SocialMediaManageScreen = lazy(() => import("../../screens/admin/SocialMediaManageScreen"));
const HistorySettingsScreen = lazy(() => import("../../screens/admin/HistorySettingsScreen"));
const ActivityParticipantsScreen = lazy(() => import("../../screens/admin/discount/ActivityParticipantsScreen"));
const StoreRoomStatusScreen = lazy(() => import("../../screens/admin/store/StoreRoomStatusScreen"));
const StoreReservationStatusScreen = lazy(() => import("../../screens/admin/store/StoreReservationStatusScreen"));
const StoreReservationListScreen = lazy(() => import("../../screens/admin/store/StoreReservationListScreen"));

export const adminRoutes = [
    {
        path: "/setting",
        uid: UIDs.screens.admin.setting,
        layout: "/admin",
        element: SettingScreen,
    }, 
    {
        path: "/servicesetting",
        uid: UIDs.screens.admin.servicesetting,
        layout: "/admin",
        element: ServiceSettingScreen,
    },
    {
        path: "/oncallsetting",
        uid: UIDs.screens.admin.oncallsetting,
        layout: "/admin",
        element: OnCallSettingScreen,
    },
    {
        path: "/currency",
        uid: UIDs.screens.admin.currency,
        layout: "/admin",
        element: CurrencySettingScreen,
    },
    {
        path: "/featureconfiguration",
        uid: UIDs.screens.admin.featureconfiguration,
        layout: "/admin",
        element: FeatureConfigurationScreen,
    },
    {
        path: "/user/userdetail",
        uid: UIDs.screens.admin.user.userdetail,
        layout: "/admin",
        element: UserDetailScreen,
    },
    {
        path: "/user/authentication",
        uid: UIDs.screens.admin.user.userauthentication,
        layout: "/admin",
        element: UserAuthenticationScreen,
    },
    {
        path: "/reservationdetail",
        uid: UIDs.screens.admin.reservationdetail,
        layout: "/admin",
        element: ReservationDetailScreen,
    },
    {
        path: "/user/manageprovider",
        uid: UIDs.screens.admin.user.manageprovider,
        layout: "/admin",
        element: ManageProviderScreen,
    },
    {
        path: "/user/manageemployee",
        uid: UIDs.screens.admin.user.manageemployee,
        layout: "/admin",
        element: ManageEmployeeScreen,
    },
    {
        path: "/user/manageconsumer",
        uid: UIDs.screens.admin.user.manageconsumer,
        layout: "/admin",
        element: ManageConsumerScreen,
    },
    {
        path: "/user/manageregionuser",
        uid: UIDs.screens.admin.user.manageregionuser,
        layout: "/admin",
        element: ManageRegionUserScreen,
    },
    {
        path: "/user/useractivity",
        uid: UIDs.screens.admin.user.useractivity,
        layout: "/admin",
        element: UserActivityScreen,
    },
    {
        path: "/user/managestoreuser",
        uid: UIDs.screens.admin.user.managestoreuser,
        layout: "/admin",
        element: ManageStoreUserScreen,
    },
    {
        path: "/user/managecloudstoreuser",
        uid: UIDs.screens.admin.user.managecloudstoreuser,
        layout: "/admin",
        element: ManageCloudStoreUserScreen,
    },
    {
        path: "/user/managemarketer",
        uid: UIDs.screens.admin.user.managemarketer,
        layout: "/admin",
        element: ManageMarketerScreen,
    },
    {
        path: "/user/manageagent",
        uid: UIDs.screens.admin.user.manageagent,
        layout: "/admin",
        element: ManageAgentScreen,
    },
    {
        path: "/teamcertification/:requestId/detail",
        uid: UIDs.screens.admin.user.teamcertificationmanagementdetail,
        layout: "/admin",
        element: TeamCertificationManagementDetailScreen,
    },
    {
        path: "/teamcertification",
        uid: UIDs.screens.admin.user.teamcertificationmanagement,
        layout: "/admin",
        element: TeamCertificationManagementScreen,
    },
    {
        path: "/servicetype",
        uid: UIDs.screens.admin.servicetype,
        layout: "/admin",
        element: ServiceTypeScreen,
    },
    {
        path: "/service",
        uid: UIDs.screens.admin.service,
        layout: "/admin",
        element: ServiceScreen,
    },
    {
        path: "/region",
        uid: UIDs.screens.admin.region,
        layout: "/admin",
        element: RegionScreen,
    },
    {
        path: "/store/default",
        uid: UIDs.screens.admin.store.default,
        layout: "/admin",
        element: StoreScreen,
    },
    {
        path: "/store/detail",
        uid: UIDs.screens.admin.store.detail,
        layout: "/admin",
        element: StoreDetailScreen,
    },
    {
        path: "/store/account",
        uid: UIDs.screens.admin.store.account,
        layout: "/admin",
        element: StoreAccountScreen,
    },
    {
        path: "/store/dashboard",
        uid: UIDs.screens.admin.store.dashboard,
        layout: "/admin",
        element: StoreDashboardScreen,
    },
    
    {
        path: "/store/roomtypes",
        uid: UIDs.screens.admin.store.storeroomtype,
        layout: "/admin",
        element: StoreRoomTypeScreen,
    },
    {
        path: "/store/rooms",
        uid: UIDs.screens.admin.store.storeroom,
        layout: "/admin",
        element: StoreRoomScreen,
    },
    {
        path: "/store/providers",
        uid: UIDs.screens.admin.store.storeprovider,
        layout: "/admin",
        element: StoreProviderScreen,
    },
    {
        path: "/store/guests",
        uid: UIDs.screens.admin.store.storeguest,
        layout: "/admin",
        element: StoreGuestScreen,
    },
    {
        path: "/store/collectionbill/detail",
        uid: UIDs.screens.admin.store.collectionbilldetail,
        layout: "/admin",
        element: StoreCollectionBillDetailScreen,
    },
    {
        path: "/store/collectionbill",
        uid: UIDs.screens.admin.store.collectionbill,
        layout: "/admin",
        element: StoreCollectionBillScreen,
    },
    {
        path: "/store/settlementpayout/detail",
        uid: UIDs.screens.admin.store.settlementpayoutdetail,
        layout: "/admin",
        element: StoreSettlementPayoutDetailScreen,
    },
    {
        path: "/store/settlementpayout",
        uid: UIDs.screens.admin.store.settlementpayout,
        layout: "/admin",
        element: StoreSettlementPayoutScreen,
    },
    {
        path: "/store/providercommission/detail",
        uid: UIDs.screens.admin.store.providercommissiondetail,
        layout: "/admin",
        element: StoreProviderCommissionDetailScreen,
    },
    {
        path: "/store/providercommission",
        uid: UIDs.screens.admin.store.providercommission,
        layout: "/admin",
        element: StoreProviderCommissionScreen,
    },
    {
        path: "/store/expenseledger/detail",
        uid: UIDs.screens.admin.store.expenseledgerdetail,
        layout: "/admin",
        element: StoreExpenseLedgerDetailScreen,
    },
    {
        path: "/store/expenseledger",
        uid: UIDs.screens.admin.store.expenseledger,
        layout: "/admin",
        element: StoreExpenseLedgerScreen,
    },
    {
        path: "/store/coupon",
        uid: UIDs.screens.admin.store.coupon,
        layout: "/admin",
        element: StoreCouponScreen,
    },
    {
        path: "/store/providerschedule",
        uid: UIDs.screens.admin.store.storeproviderschedule,
        layout: "/admin",
        element: StoreProviderScheduleScreen,
    },
    {
        path: "/store/services",
        uid: UIDs.screens.admin.store.storeservice,
        layout: "/admin",
        element: StoreServiceScreen,
    },
    {
        path: "/regionservice",
        uid: UIDs.screens.admin.regionservice,
        layout: "/admin",
        element: RegionServiceScreen,
    },
    {
        path: "/regionsetting",
        uid: UIDs.screens.admin.regionsetting,
        layout: "/admin",
        element: RegionSettingScreen,
    },
    {
        path: "/storejoinrequest",
        uid: UIDs.screens.admin.storejoinrequest,
        layout: "/admin",
        element: StoreJoinRequestScreen,
    },
    {
        path: "/todotask",
        uid: UIDs.screens.admin.todotask,
        layout: "/admin",
        element: TodoTaskScreen,
    },
    {
        path: "/regionjoinrequest/:requestId/detail",
        uid: UIDs.screens.admin.regionjoinrequestdetail,
        layout: "/admin",
        element: RegionJoinRequestDetailScreen,
    },
    {
        path: "/regionjoinrequest",
        uid: UIDs.screens.admin.regionjoinrequest,
        layout: "/admin",
        element: RegionJoinRequestScreen,
    },
    {
        path: "/feedback/:feedbackId/detail",
        uid: UIDs.screens.admin.manager.feedbackdetail,
        layout: "/admin",
        element: FeedbackDetailScreen,
    },
    {
        path: "/feedback",
        uid: UIDs.screens.admin.manager.feedback,
        layout: "/admin",
        element: FeedbackScreen,
    },
    {
        path: "/report/:reportId/detail",
        uid: UIDs.screens.admin.manager.reportdetail,
        layout: "/admin",
        element: ReportDetailScreen,
    },
    {
        path: "/report",
        uid: UIDs.screens.admin.manager.report,
        layout: "/admin",
        element: ReportScreen,
    },
    {
        path: "/gpsmonitor",
        uid: UIDs.screens.admin.gpsmonitor,
        layout: "/admin",
        element: GpsMonitorScreen,
    },
    {
        path: "/verifycodemanage",
        uid: UIDs.screens.admin.verifycodemanage,
        layout: "/admin",
        element: VerifyCodeManageScreen,
    },
    {
        path: "/helpcentersetting",
        uid: UIDs.screens.admin.helpcentersetting,
        layout: "/admin",
        element: HelpCenterSettingScreen,
    },
    {
        path: "/workbench",
        uid: UIDs.screens.admin.workbench,
        layout: "/admin",
        element: WorkbenchScreen,
    },
    {
        path: "/dashboard",
        uid: UIDs.screens.admin.dashboard,
        layout: "/admin",
        element: DashboardScreen,
    },
    {
        path: "/error/list",
        uid: UIDs.screens.admin.error.list,
        icon: "ni ni-notification-70 text-primary",
        element: ErrorListScreen,
        layout: "/admin",
        name: "error",
    },
    {
        path: "/error/dashboard",
        uid: UIDs.screens.admin.error.dashboard,
        icon: "ni ni-notification-70 text-primary",
        element: ErrorDashboardScreen,
        layout: "/admin",
        name: "errorDashBoard",
    },
    {
        path: "/error/:id/details",
        uid: UIDs.screens.admin.error.details,
        icon: "ni ni-folder-17 text-purple",
        element: ErrorDetailsScreen,
        layout: "/admin",
    },
    {
        path: "/userstatistic",
        uid: UIDs.screens.admin.statistics.userstatistic,
        layout: "/admin",
        element: UserStatisticScreen,
    },
    {
        path: "/providerstatistic",
        uid: UIDs.screens.admin.statistics.providerstatistic,
        layout: "/admin",
        element: ProviderStatisticScreen,
    },
    {
        path: "/marketerstatistic",
        uid: UIDs.screens.admin.statistics.marketerstatistic,
        layout: "/admin",
        element: MarketerStatisticScreen,
    },
    {
        path: "/orderstatistic",
        uid: UIDs.screens.admin.statistics.orderstatistic,
        layout: "/admin",
        element: OrderStatisticScreen,
    },
    {
        path: "/incomestatistic",
        uid: UIDs.screens.admin.statistics.incomestatistic,
        layout: "/admin",
        element: IncomeStatisticScreen,
    },
    {
        path: "/operationstatistic",
        uid: UIDs.screens.admin.statistics.operationstatistic,
        layout: "/admin",
        element: OperationStatisticScreen,
    },
    {
        path: "/providerwithdrawal",
        uid: UIDs.screens.admin.transaction.providerwithdrawal,
        layout: "/admin",
        element: ProviderWithdrawalScreen,
    },
    {
        path: "/consumerwithdrawal",
        uid: UIDs.screens.admin.transaction.consumerwithdrawal,
        layout: "/admin",
        element: ConsumerWithdrawalScreen,
    },
    {
        path: "/marketerwithdrawal",
        uid: UIDs.screens.admin.transaction.marketerwithdrawal,
        layout: "/admin",
        element: MarketerWithdrawalScreen,
    },
    {
        path: "/regionwithdrawal",
        uid: UIDs.screens.admin.transaction.regionwithdrawal,
        layout: "/admin",
        element: RegionWithdrawalScreen,
    },
    {
        path: "/storewithdrawal",
        uid: UIDs.screens.admin.transaction.storewithdrawal,
        layout: "/admin",
        element: StoreWithdrawalScreen,
    },
    {
        path: "/agentwithdrawal",
        uid: UIDs.screens.admin.transaction.agentwithdrawal,
        layout: "/admin",
        element: AgentWithdrawalScreen,
    },
    {
        path: "/reservation",
        uid: UIDs.screens.admin.reservation,
        layout: "/admin",
        element: ReservationScreen,
    },
    {
        path: "/reservationrewardpenalty",
        uid: UIDs.screens.admin.reservationrewardpenalty,
        layout: "/admin",
        element: ReservationRewardPenaltyScreen,
    },
    {
        path: "/debt",
        uid: UIDs.screens.admin.debt,
        layout: "/admin",
        element: DebtScreen,
    },
    {
        path: "/coupon",
        uid: UIDs.screens.admin.discount.coupon,
        layout: "/admin",
        element: CouponScreen,
    },
    {
        path: "/promotion",
        uid: UIDs.screens.admin.discount.promotion,
        layout: "/admin",
        element: PromotionScreen,
    },
    {
        path: "/regionreservation",
        uid: UIDs.screens.admin.regionreservation,
        layout: "/admin",
        element: RegionReservationScreen,
    },
    {
        path: "/cloudstore",
        uid: UIDs.screens.admin.cloudstore,
        layout: "/admin",
        element: CloudStoreScreen,
    },
    {
        path: "/cloudstorerequest",
        uid: UIDs.screens.admin.cloudstorerequest,
        layout: "/admin",
        element: CloudStoreRequestScreen,
    },
    {
        path: "/chat/:id/home",
        uid: UIDs.screens.admin.chat.chat,
        layout: "/admin",
        element: ChatHomeScreen,
    }, {
        path: "/chat/list",
        uid: UIDs.screens.admin.chat.list,
        layout: "/admin",
        element: ChatListScreen,
    },
    {
        path: "/consumerreview/:reviewId/detail",
        uid: UIDs.screens.admin.manager.consumerreviewdetail,
        layout: "/admin",
        element: ConsumerReviewDetailScreen,
    },
    {
        path: "/consumerreview",
        uid: UIDs.screens.admin.manager.consumerreview,
        layout: "/admin",
        element: ConsumerReviewScreen,
    },
    {
        path: "/providerreview/:reviewId/detail",
        uid: UIDs.screens.admin.manager.providerreviewdetail,
        layout: "/admin",
        element: ProviderReviewDetailScreen,
    },
    {
        path: "/providerreview",
        uid: UIDs.screens.admin.manager.providerreview,
        layout: "/admin",
        element: ProviderReviewScreen,
    },
    {
        path: "/activeuserconfig",
        uid: UIDs.screens.admin.statistics.activeuserconfig,
        layout: "/admin",
        element: ActiveUserConfigScreen,
    },
    {
        path: "/income/regions",
        uid: UIDs.screens.admin.income.regionincomelist,
        layout: "/admin",
        element: RegionIncomeListScreen,
    },
    {
        path: "/income/system",
        uid: UIDs.screens.admin.income.systemincome,
        layout: "/admin",
        element: SystemIncomeScreen,
    },
    {
        path: "/datavalidation",
        uid: UIDs.screens.admin.income.systemincomevalidation,
        layout: "/admin",
        element: SystemIncomeValidationScreen,
    },
    {
        path: "/mockdata",
        uid: UIDs.screens.admin.mockdata,
        layout: "/admin",
        element: MockDataScreen,
    },
    {
        path: "/datacleanup",
        uid: UIDs.screens.admin.datacleanup,
        layout: "/admin",
        element: DataCleanupScreen,
    },
    {
        path: "/profile",
        uid: UIDs.screens.admin.profile,
        layout: "/admin",
        element: ProfileScreen,
    },
    {
        path: "/chooseregion",
        uid: UIDs.screens.admin.chooseregion,
        layout: "/admin",
        element: ChooseRegionScreen,
    },
    {
        path: "/account",
        uid: UIDs.screens.admin.account,
        layout: "/admin",
        element: AccountScreen,
    },
    {
        path: "/announcement",
        uid: UIDs.screens.admin.discount.announcement,
        layout: "/admin",
        element: AnnouncementScreen,
    },
    {
        path: "/request/cancelreservationwithoutliability/:requestId/detail",
        uid: UIDs.screens.admin.request.cancelReservationWithoutLiabilityRequest,
        layout: "/admin",
        element: CancelReservationWithoutLiabilityRequestScreen,
    },
    {
        path: "/request/rejectreservation/:requestId/detail",
        uid: UIDs.screens.admin.request.rejectReservationRequest,
        layout: "/admin",
        element: RejectReservationRequestScreen,
    },
    {
        path: "/request/reservationrefund/:requestId/detail",
        uid: UIDs.screens.admin.request.reservationRefundRequest,
        layout: "/admin",
        element: ReservationRefundRequestScreen,
    },
    {
        path: "/request/newservicetype/:requestId/detail",
        uid: UIDs.screens.admin.request.newServiceTypeRequest,
        layout: "/admin",
        element: NewServiceTypeRequestScreen,
    },
    {
        path: "/request/userwithdrawal/:itemType/:requestId/detail",
        uid: UIDs.screens.admin.request.userWithdrawalRequest,
        layout: "/admin",
        element: UserWithdrawalRequestScreen,
    },
    {
        path: "/request/reservationrewardpenalty/:requestId/detail",
        uid: UIDs.screens.admin.request.reservationRewardPenaltyRequest,
        layout: "/admin",
        element: ReservationRewardPenaltyRequestScreen,
    },
    {
        path: "/request/freereservation/:requestId/detail",
        uid: UIDs.screens.admin.request.freeReservationRequest,
        layout: "/admin",
        element: FreeReservationRequestScreen,
    },
    {
        path: "/request/teamcertification/:requestId/detail",
        uid: UIDs.screens.admin.request.teamCertificationRequest,
        layout: "/admin",
        element: TeamCertificationRequestScreen,
    },
    {
        path: "/request/providerstorejoin/:requestId/detail",
        uid: UIDs.screens.admin.request.providerStoreJoinRequest,
        layout: "/admin",
        element: ProviderStoreJoinRequestScreen,
    },
    {
        path: "/income/consumer",
        uid: UIDs.screens.admin.income.consumerincome,
        layout: "/admin",
        element: ConsumerIncomeScreen,
    },
    {
        path: "/income/provider",
        uid: UIDs.screens.admin.income.providerincome,
        layout: "/admin",
        element: ProviderIncomeScreen,
    },
    {
        path: "/income/marketer",
        uid: UIDs.screens.admin.income.marketerincome,
        layout: "/admin",
        element: MarketerIncomeScreen,
    },
    {
        path: "/freereservation",
        uid: UIDs.screens.admin.discount.freereservation,
        layout: "/admin",
        element: FreeReservationScreen,
    },
    {
        path: "/poster",
        uid: UIDs.screens.admin.discount.poster,
        layout: "/admin",
        element: PosterScreen,
    },
    {
        path: "/socialmediamanage",
        uid: UIDs.screens.admin.socialmediamanage,
        layout: "/admin",
        element: SocialMediaManageScreen,
    },
    {
        path: "/historysettings",
        uid: UIDs.screens.admin.historysettings,
        layout: "/admin",
        element: HistorySettingsScreen,
    },
    {
        path: "/activityparticipants",
        uid: UIDs.screens.admin.discount.activityparticipants,
        layout: "/admin",
        element: ActivityParticipantsScreen,
    },
    {
        path: "/roomstatus",
        uid: UIDs.screens.admin.store.roomstatus,
        layout: "/admin",
        element: StoreRoomStatusScreen,
    },
    {
        path: "/reservationstatus",
        uid: UIDs.screens.admin.store.reservationstatus,
        layout: "/admin",
        element: StoreReservationStatusScreen,
    },
    {
        path: "/reservationlist",
        uid: UIDs.screens.admin.store.reservationlist,
        layout: "/admin",
        element: StoreReservationListScreen,
    },
];
